import c from 'classnames';

/**
 * Calculates the CSS classes for product cards on tablet devices to hide excess products.
 * This prevents half-filled rows by hiding products that would not fill an entire row.
 * Also used in the DynamicProductListingCards component.
 *
 * @param {number} index - The index of the product card in the list.
 * @param {number} numProducts - The total number of product cards.
 * @returns {string} - A string of class names to be applied to the product card.
 */
export const getProductCardTabletClasses = (
  index: number,
  numProducts: number,
  // The min-width pair sizes cards in the horizontal scroll rows below md
  // (264px fits the widest allowed price row incl. the countdown pill,
  // CPS-7269 — the scroll absorbs the width; keep in sync with the 13rem
  // grid floors in ResultList and PublisherProfile/ProductRow). Grid parents
  // (PublisherAssets) must pass false: their tracks size the cards, and an
  // item min-width larger than a minmax() track overflows it, overlapping
  // neighbors at narrow viewports. Required (no default) so new consumers
  // opt in to the overflow-prone min-width behavior deliberately.
  isScrollRow: boolean
) => {
  const COLUMNS_TABLET = 4;
  const hiddenIndexThreshold = numProducts - (numProducts % COLUMNS_TABLET);

  return c('mr-0', isScrollRow && 'min-w-[264px] md:min-w-full', {
    'md:hidden lg:block': index >= hiddenIndexThreshold,
  });
};
